import React from "react";
import { connect } from "react-redux";
import SupportingText from "../SupportingText";

const mapStateToProps = ({ auth }) => ({
  currentUser: auth.currentUser
});

class Adress extends React.Component {
  render() {
    const {
      currentUser: { street, place, country }
    } = this.props;
    return (
      <div className="w-full py-2">
        <SupportingText text="black" fontWeight="thin" textSize="base">
          Straße: {street}
        </SupportingText>
        <SupportingText text="black" fontWeight="thin" textSize="base">
          Ort: {place}
        </SupportingText>
        <SupportingText text="black" fontWeight="thin" textSize="base">
          Land: {country === "D" ? "Deutschland" : `${country}`}
        </SupportingText>
        <div className="py-4">
          <SupportingText text="black" fontWeight="thin" textSize="base">
            Ihre Rechnungsadresse entspricht der Lieferadresse
          </SupportingText>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, null)(Adress);



// WEBPACK FOOTER //
// ./src/Adress/Adress.js